import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import {  Col, FormGroup } from "react-bootstrap";
import {  Field, reduxForm, propTypes,formValueSelector, } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import {
	saveEventDetails,
	setDefaultWeeks,
	prestineNavigateNext,
	setEventType,
	resetWizardState
} from "../../../../redux/actions/action_event";
import {  forms,style,blue,warning, gray, eventtypesEnum, StatusDescription } from "../../../../utils/constants";
import { renderOptionsField } from '../../../../modules/components/fieldoptioncomponent';
import { STEP_SEQUENCE } from '../../logic';
import EventDetailsFields  from './fields'

const sectionBorder = {
	border:`1px solid ${gray}`,
	padding:'15px',
	marginRight:'0px',
	marginBottom:'15px'
}

const FormName = forms.eventinfo
class EventDetails extends Component {
 
	static propTypes = {
		...propTypes
	}

	constructor(props)
	{  
		super(props);
		this.areDetailsEqual  = this.areDetailsEqual.bind(this);
		this.saveEventDetails = this.saveEventDetails.bind(this);
		this.handleNotToExceedLength = this.handleNotToExceedLength.bind(this);
		this.handleNegativeNumbers = this.handleNegativeNumbers.bind(this);
	}
	componentDidMount() {
		window.scrollTo(0, 0)
		this.props.dispatch(resetWizardState(STEP_SEQUENCE.EventDetails));
	}
   
	saveEventDetails()
	{
		const { areDetailsEqual } = this
		const { 
			dispatch,eventId,numberofweeks, numberofgames, certificationnumber, eventtype,prestineeventdetails, seasons, eventseason 
		} = this.props

		const season = _.find(seasons, { id:parseInt(eventseason) });

		const saveDetails   = !areDetailsEqual(prestineeventdetails,this.props)
		// if information has not changed then there is no need to save it
		if (saveDetails === true) {
			const details = {
				eventId:eventId,
				numberofweeks,
				numberofgames,
				certificationnumber,
				eventtype,
				step:2,
				season:season
			}
			dispatch(saveEventDetails(eventId,details));
		}
		else{
			dispatch(prestineNavigateNext());
		}
	}

	areDetailsEqual (original,current) {
		let equal = true
		if((original != undefined) && (current != undefined))
		{
			if (	original.eventType !== current.eventtype	) {
				equal = false
			}
			if ((original.numberOfGames !== current.numberofgames) || (original.numberOfGames === undefined) || (original.numberOfGames === null)) {
				equal = false
			}
			if (	original.numberOfWeeks !== current.numberofweeks	) {
				equal = false
			}
			if (	original.certificationNumber !== current.certificationnumber	) {
				equal = false
			}
		}
		else {
			equal = false
		}
		return equal		
	}

	handleNotToExceedLength(evt)
	{
		const { value } = evt.target;
		if((value.length > 3) )
		{
			return evt.target.value = value.substring(0,3);
		}
	}

	handleNegativeNumbers(evt){
		if (evt.which === 109 || evt.which === 189) {
			evt.preventDefault();
		}
	}

	generateUpdateErrors(eventDetailsErrors)
	{
		const error = eventDetailsErrors.map((key,index) => {
			return (<li key={index} style={{ color:warning }}>{this.props.updateDetailsErrors[key]}</li>)
		})
		return error;
	}
	render() {
		const { 
			dispatch,
			eventname,
			numberofweeks,
			startdate,
			enddate,
			eventtype,
			saveComponentState,
			handleSubmit, 
			componentStateSaved,
			currentWizardStep,
			updateDetailsErrors,
            roleName,
            status
		} = this.props;

        const isAdministrator = roleName == 'Administrator';
		const eventTypes = Object.getOwnPropertyNames(eventtypesEnum);
		const leagueEvent = (eventtype === eventtypesEnum.League);
		const eventDetailsErrors = Object.keys(updateDetailsErrors);
		const weeksSpecified = (numberofweeks !== undefined && numberofweeks !== null);
		let weeks = null;
		
		if(leagueEvent && !weeksSpecified )
		{
			// set default value for weeks
			weeks = moment.duration(moment(enddate).diff(moment(startdate))).asWeeks() + 1;
			dispatch(setDefaultWeeks(Math.floor(weeks)));
		}

		if(currentWizardStep === STEP_SEQUENCE.EventDetails)
		{
			if((saveComponentState === true) && (componentStateSaved === false))
			{
				this.saveEventDetails();
			}
			if(componentStateSaved === true)
			{
				this.props.onComponentStateSaved(componentStateSaved)
			}
			if(eventDetailsErrors.length > 0)
			{
				this.props.onComponentStateSaved(false)
			} 
		}

		return (
			<div style={{ marginTop:'1%' }} sm={5}>
			<form  onSubmit={handleSubmit} className="form-horizontal">
				{
					eventDetailsErrors.length > 0 && 
					(<Col sm={12} style={sectionBorder}>
							<h4 style={{ color: warning }}>* Please correct the following errors to proceed:</h4>
							<ul>
							{
								this.generateUpdateErrors(eventDetailsErrors)
							}
							</ul>
						</Col>)
				}
				
					<Col md={12} lg={7} style={{ border:`1px solid ${gray}`, padding:'15px' , marginRight:'0px', marginBottom:'15px' }} >
						<FormGroup style={{ padding:'0 0 15px 25px', margin:'0' }}>
							<h4 className='text-left'  style={{ color:blue }}>
								{' '}Event Name - {eventname},{' '} {moment(startdate).format('LL')}&nbsp;{'-'}&nbsp;{moment(enddate).format('LL')}
							</h4>
						</FormGroup>
						<FormGroup>
							<Field
								label='Event Type'
								labelattrs = {style.lblattrs}
								inputattrs = {style.inputattrsSmall}
								name='eventType'
								id='eventType'
								values={[
									{ name:eventTypes[2], abbreviation:eventtypesEnum.Tournament },
									{ name:eventTypes[1], abbreviation:eventtypesEnum.League  },
								]}
								onChange={this.handleEventTypeChange} 
								component={renderOptionsField}
                                disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}
							/>
            </FormGroup>
            {
              leagueEvent &&
              (<span style={{ fontSize: '14px', fontWeight: 'bold', padding:'65px', color:warning }}>
                <i className="fa fa-info-circle" aria-hidden="true" />&nbsp;&nbsp;Enter the total number of games for the entire league season.
              </span>)
            }
						<FormGroup>
							<label className={style.lblattrs3}>Total Number of Games&nbsp;</label>
							<Field
								type='number'
								name={EventDetailsFields.NumberOfGames}
								component='input'
								min={0}
								className="form-control no-spinners"
								style={{ maxWidth: '70px' }}
								onKeyDown={this.handleNegativeNumbers}   
								onKeyUp={this.handleNotToExceedLength}
                                disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}
							/>
						</FormGroup>
						{
							leagueEvent && (<FormGroup>
							<label className={style.lblattrs3}>Number of Weeks&nbsp;</label>
							<Field
								type='number'
								name={EventDetailsFields.NumberOfWeeks}
								component='input'
								className="form-control no-spinners"
								style={{ maxWidth: '70px' }}
								onKeyDown={this.handleNegativeNumbers}  
								onKeyUp={this.handleNotToExceedLength}
                                disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}
							/>
						</FormGroup>)
						}
						<FormGroup>
							<label className={style.lblattrs3}>Certification Number&nbsp;</label>
							<Field
								type='number'
								name={EventDetailsFields.CertificationNumber}
								component='input'
								max={999}
								className="form-control no-spinners"
								style={{ maxWidth: '150px' }}
								onKeyDown={this.handleNegativeNumbers}
								onChange={this.handleValueChange}
                                disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}
							/>
						</FormGroup>
					</Col>
			</form>   
			</div>)
	}
}
function mapStateToProps(state,ownProps){
	const formName =  ownProps.form;
	const selector = formValueSelector(formName);
	const eventId  = selector(state,'eventId');
	const eventname = selector(state,'eventname');
	const startdate = selector(state,'startdate');
	const enddate = selector(state,'enddate');
	const eventtype = selector(state,EventDetailsFields.EventType);
	const numberofgames = selector(state,'numberOfGames');
	const numberofweeks = selector(state,'numberOfWeeks');
	const certificationnumber = selector(state,EventDetailsFields.CertificationNumber);
	const savingData = selector(state,'savingData');
	const prestineeventdetails  = selector(state,'prestineeventdetails');
	const seasons	= selector(state,'seasons');
	const eventseason	= selector(state,'eventseason');
	const componentStateSaved = selector(state,'componentStateSaved');
	const currentWizardStep	= selector(state,'currentWizardStep');
	const updateDetailsErrors = selector(state,'updateDetailsErrors');
    const status = selector(state, 'status')
    const roleName = state.user.roleName
  return {
		seasons,
		eventseason,
		eventname,
		startdate,
		enddate,
		eventId,
		eventtype,
		numberofgames,
		numberofweeks,
		certificationnumber,
		savingData,
		prestineeventdetails,
		user:state.user,
		componentStateSaved,
		updateDetailsErrors,
        currentWizardStep,
        roleName,
        status
	}
}  
function mapDispatchToProps(dispatch){
	return bindActionCreators({
		saveEventDetails,
		setDefaultWeeks,
		setEventType,
	},dispatch);
}
EventDetails.propTypes = {
	handleSubmit:PropTypes.func,
	previousPage:PropTypes.func,
	dispatch:PropTypes.func,
	saveEventDetails: PropTypes.func,
	setDefaultWeeks: PropTypes.func,
	eventId:PropTypes.number,
	eventname:PropTypes.string,
	startdate:PropTypes.string,
	enddate:PropTypes.string,
	numberofgames:PropTypes.number,
	numberofweeks:PropTypes.number,
	eventseason: PropTypes.string,
	certificationnumber:PropTypes.number,
	eventtype:PropTypes.string,
	savingData:PropTypes.bool,
	prestineeventdetails:PropTypes.object,
	user:PropTypes.object,
	saveComponentState: PropTypes.bool,
	onComponentStateSaved: PropTypes.func,
	seasons: PropTypes.array,
	updateDetailsErrors: PropTypes.object,
	componentStateSaved: PropTypes.bool,
    currentWizardStep: PropTypes.number,
    roleName: PropTypes.string,
    status: PropTypes.string
};
function validate(values) {
	const errors = {};
	if(!values.numberOfGames){
		errors.numberOfGames = 'Please enter number of games';
	}
	return errors;
}
export default reduxForm({
	validate,
	form:FormName,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: false
})(connect(mapStateToProps,mapDispatchToProps)(EventDetails));
    



// WEBPACK FOOTER //
// ./src/containers/event/components/eventDetails/index.js